// Subscriptions page - products section add to cart
function addItemToCart(variantId) {
  const data = {
    id: variantId,
    quantity: 1,
  };
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

function refreshHeaderHeight() {
  var windowWidth = $(window).width();
  if(windowWidth > 500) {
    var headerHeight = $(".tt-mobile-header").innerHeight();
    $("#tt-pageContent").css("margin-top", headerHeight);
  }
  else if(windowWidth > 1024){
    var headerHeight = $(".tt-desktop-header").innerHeight();
    $("#tt-pageContent").css("margin-top", headerHeight);
  }
  else{
    var headerHeight = $(".tt-mobile-header").innerHeight();
    $("#tt-pageContent").css("margin-top", '86px');
  }
}

refreshHeaderHeight();
jQuery(window).resize(function () {
  refreshHeaderHeight();
  marqueeTopHeader();
});

const productItems = document.querySelectorAll(".subscriptions-products-item");
if (productItems.length > 0) {
  productItems.forEach((item) => {
    let addToCartButton = item.querySelector(
      ".js-subscriptions-products-add-item"
    );
    if (addToCartButton !== null) {
      addToCartButton.addEventListener("click", (evt) => {
        evt.preventDefault();
        const variantId = evt.target.dataset.vid;
        addItemToCart(variantId)
          .then((response) => {
            let { ok, status } = response;
            if (ok && status === 200) window.location.href = "/cart";
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
    }
  });
}

// Subscription page - FAQ section accordion
class SubscriptionsAccordion {
  constructor(root) {
    this.root = root;
    this.accordionItems = root.querySelectorAll(".subscriptions-faq__tab");
    this.init();
  }

  reset() {
    this.accordionItems.forEach((item) => item.classList.remove("active"));
  }

  show(accordionItem) {
    if (accordionItem.classList.contains("active")) {
      accordionItem.classList.remove("active");
      return;
    }
    this.reset();
    accordionItem.classList.contains("active")
      ? accordionItem.classList.remove("active")
      : accordionItem.classList.add("active");
  }

  init() {
    const show = this.show.bind(this);
    this.accordionItems.forEach((item) => {
      item.addEventListener("click", (evt) => {
        show(evt.currentTarget);
      });
    });
  }
}

$(".insta-carousel").slick({
  speed: 5000,
  autoplay: true,
  arrows: false,
  autoplaySpeed: 0,
  centerMode: true,
  cssEase: "linear",
  slidesToShow: 4,
  slidesToScroll: 4,
  variableWidth: true,
  infinite: true,
  initialSlide: 1,
  buttons: false,
});

marqueeTopHeader();

jQuery(document).ready(function () {
  marqueeTopHeader();
});

function marqueeTopHeader() {
  jQuery(".marquee-header-topbar").slick({
  speed: 25000,
  autoplay: true,
  arrows: false,
  autoplaySpeed: 0,
  centerMode: true,
  cssEase: "linear",
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  infinite: true,
  initialSlide: 1,
  buttons: false,
});
}

const subscriptionRoot = document.querySelector(".subscriptions-faq__tabs");
if (subscriptionRoot !== null) {
  const accordion = new SubscriptionsAccordion(subscriptionRoot);
}

jQuery(document).ready(function() {
    // Event delegation to handle form submission
    jQuery(document).on('submit', '.ghc-contact-form', function(e) {
        e.preventDefault(); // Prevent the default form submission behavior

        // Scroll to the top of the #shopify-section-contact_us_form section
        jQuery('#shopify-section-contact_us_form').animate({scrollTop: 0}, 800);

        // Show the loading spinner
        jQuery('.load').fadeIn(500);

        // Perform form submission asynchronously
        var formData = new FormData(this);

        // Now you can customize your form submission process
        // For example, you can use Ajax to submit the form data to your server
        jQuery.ajax({
            url: 'your_server_url',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                // Handle the response after form submission is complete
                console.log(response);
            },
            error: function(xhr, status, error) {
                // Handle errors if any
                console.error(xhr, status, error);
            },
            complete: function() {
                // Hide the loading spinner when the submission is complete
                jQuery('.load').fadeOut(500);
            }
        });
    });
});

 window.onload = function() {
            document.getElementById('flashing-banner').style.animationPlayState = 'running';
        };

!function(t,e){"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?module.exports=e():t.Marquee3k=e()}(this,(function(){"use strict";class t{constructor(t,e){this.element=t,this.selector=e.selector,this.speed=t.dataset.speed||.25,this.pausable=t.dataset.pausable,this.reverse=t.dataset.reverse,this.paused=!1,this.parent=t.parentElement,this.parentProps=this.parent.getBoundingClientRect(),this.content=t.children[0],this.innerContent=this.content.innerHTML,this.wrapStyles="",this.offset=0,this._setupWrapper(),this._setupContent(),this._setupEvents(),this.wrapper.appendChild(this.content),this.element.appendChild(this.wrapper)}_setupWrapper(){this.parent.style.overflowX="hidden",this.wrapper=document.createElement("div"),this.wrapper.classList.add("marquee3k__wrapper"),this.wrapStyles="white-space: nowrap;",this.wrapper.setAttribute("style",this.wrapStyles)}_setupContent(){this.content.classList.add(`${this.selector}__copy`),this.content.style.display="inline-block",this.contentWidth=this.content.offsetWidth,this.requiredReps=this.contentWidth>this.parentProps.width?2:Math.ceil((this.parentProps.width-this.contentWidth)/this.contentWidth)+1;for(let t=0;t<this.requiredReps;t++)this._createClone();this.reverse&&(this.offset=-1*this.contentWidth),this.element.classList.add("is-init")}_setupEvents(){this.element.addEventListener("mouseenter",(()=>{this.pausable&&(this.paused=!0)})),this.element.addEventListener("mouseleave",(()=>{this.pausable&&(this.paused=!1)}))}_createClone(){const t=document.createElement("span");t.classList.add(`${this.selector}__copy`),t.innerHTML=this.innerContent,this.wrapper.appendChild(t)}animate(){this.paused||(this.reverse?this.offset<0?this.offset+=this.speed:this.offset=-1*this.contentWidth:this.offset>-1*this.contentWidth?this.offset-=this.speed:this.offset=0,this.wrapper.setAttribute("style",`${this.wrapStyles} transform: translate3d(${this.offset}px, 0, 0);\n        `))}repopulate(t,e){if(this.contentWidth=this.content.offsetWidth,e){const e=Math.ceil(t/this.contentWidth)+1;for(let t=0;t<e;t++)this._createClone()}}static init(e={selector:"marquee3k"}){const s=[],i=document.querySelectorAll(`.${e.selector}`);let n,h=window.innerWidth;for(let n=0;n<i.length;n++){const h=i[n],r=new t(h,e);s.push(r)}!function t(){for(const t of s)t.animate();window.requestAnimationFrame(t)}(),window.addEventListener("resize",(()=>{clearTimeout(n),n=setTimeout((()=>{const t=h<window.innerWidth,e=window.innerWidth-h;for(const i of s)i.repopulate(e,t);h=this.innerWidth}))}),250)}}return t}));
//# sourceMappingURL=/sm/21a5d88e6e767ffc6ef0a1330c5392c6272a5161c95d5d0fb82f04645c5bd81b.map

Marquee3k.init();